import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getPaymentsByUser = (userId) =>
  axiosInstance.get(`${ADMIN_API_URL}/payments/get-payment/${userId}`, {
    headers: authHeaders(),
  });

export const getPayments = (dateRange = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/payments`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const removePayment = (paymentId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/payments/${paymentId}`, {
    headers: authHeaders(),
  });

export const createPaymentRequest = (paymentData) =>
  axiosInstance.post(`${ADMIN_API_URL}/payments`, paymentData, {
    headers: authHeaders(),
  });

export const updatePaymentRequest = (paymentId, paymentData) =>
  axiosInstance.post(`${ADMIN_API_URL}/payments/${paymentId}`, paymentData, {
    headers: authHeaders(),
  });

export const getUserActiveSubscription = (userId) =>
  axiosInstance.get(`${ADMIN_API_URL}/user/active/subscription/${userId}`, {
    headers: authHeaders(),
  });
